import React, { createContext, useCallback, useMemo, useState } from 'react';

export const ChangeWarrantyModalStateContext = createContext();
export const ChangeWarrantyModalDispatchContext = createContext();

export const ToggleChangeWarrantyModalProvider = ({ children }) => {
  const [modalData, setModalData] = useState(null);

  const open = useCallback((data) => setModalData(data), []);
  const close = useCallback(() => setModalData(null), []);

  const actions = useMemo(() => ({ open, close }), [open, close]);

  return (
    <ChangeWarrantyModalStateContext.Provider value={modalData}>
      <ChangeWarrantyModalDispatchContext.Provider value={actions}>
        {children}
      </ChangeWarrantyModalDispatchContext.Provider>
    </ChangeWarrantyModalStateContext.Provider>
  );
};
